export const ApxReportMenu = {
    Default:1,
    Finance:2,
    Support:3,
    ClientFacing:4
  }

  export const AccountManagementMenu = {
    Default:1,
    ReTier:2,
    DocumentRequest:3,
    Manage:4
  }

  export const APXModules = {
    Default:"1",
    Reports:"APXReports",
    Transaction:"2",
    Onboarding:"3",
    Endpoints:"4",
    AccountManagement:"AccountManagement"
  }

  export const AOModules = {
    Default:"1",
    Reports:"AOReports",
    Sales:"Sales",
    Support:"AOSupport"
  }

  export const OTModules = {
    Default:"1",   
    Sales:"OTSales",
    Support:"OTSupport"
  }

 export const MainMenuEnum = {
    Home:1,
    Apx: 2,
    AmicusOnline:3,
    OfficeTools:4
  }

  export default MainMenuEnum;

